import RenderImages from "../../../components/render-images/RenderImages";
import Banner from "../../../shared/banner/Banner";

function Gallery() {
  return (
    <>
      <Banner>
        <span>ABOUT US</span>
        <span>/</span>
        <span>GALLERY</span>
      </Banner>
      <div className="row m-0">
        <RenderImages classname="gallery-image col-lg-3 col-md-4 col-sm-6 col-12" />
      </div>
    </>
  );
}

export default Gallery;
